import Vue from 'vue'
import axios from '@/plugins/axios'

export const find = async (_, { userId, startDate, endDate }) => {
  Vue.prototype.$loading(true)

  try {
    const { data } = await axios.get(`admin/users/${userId}/usage`, {
      params: {
        startDate,
        endDate,
      },
    })

    return data
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const exportUsage = async (_, { userId, startDate, endDate }) => {
  Vue.prototype.$loading(true)

  try {
    const response = await axios.get(`admin/users/${userId}/usage/export`, {
      params: {
        startDate,
        endDate,
      },
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type:
        response.headers?.['content-type'] ||
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const fileName = `relatorio-uso-${userId}.xlsx`
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()

    setTimeout(() => {
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }, 100)

    Vue.prototype.$notify('Relatório de uso baixado com sucesso', 'success')
    return true
  } catch (err) {
    Vue.prototype.$notify('Erro ao baixar relatório de uso', 'error')
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}
